import { useViewMapQueryParams } from 'hooks/map/useViewMapQueryParams';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ViewMapPage = (props: Props): JSX.Element => {
    const { id } = useParams() as { id: string };

    const queryParamData = useViewMapQueryParams();

    useEffect(() => {
        if (queryParamData.language) {
            Localization.setLanguage(queryParamData.language);
        }
    }, [queryParamData, queryParamData.language]);

    return (
        <S_ViewMapPage className={props.className}>
            <CustomMapPage
                disableSimpleGestures={queryParamData.disableSimpleGestures}
                automaticHeader={queryParamData.showHeader}
                interactiveStyle={queryParamData.interactivityType}
                interactiveMessage={true}
                mapId={id}
                mapheimLogo
            />
        </S_ViewMapPage>
    );
};

const S_ViewMapPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
